import { RESET_ERRORS, SET_GLOBAL_ERROR } from "../type";

export const resetError = (callback) => (dispatch) => {
  dispatch({
    type: RESET_ERRORS,
  });
};

export const setGlobalError = (data) => (dispatch) => {
  const {
    code: errorCode,
    data: { message: errorMessage, title: errorTitle, scope },
  } = data.data;
  dispatch({
    type: SET_GLOBAL_ERROR,
    payload: {
      errorCode,
      errorMessage,
      errorTitle: `${scope} ${errorTitle}`,
    },
  });
};
